/* American Threads Co - Judge.me review trimming.
   Clamps each review body to two lines with a Read more toggle, and
   keeps only the first two reviews visible behind a Show more button.
   Judge.me renders asynchronously, so a MutationObserver re-runs this.
   A review that fits in two lines gets no Read more - that is on purpose.

   2026-11-04: on product pages the reviews shoppers SEE are the theme's own
   cards (snippets/atc-reviews.liquid, .atcr), and Judge.me's widget is parked
   off-screen there only so its review form keeps working. Trimming that hidden
   widget was pure wasted main-thread time (~350 ms on mobile Lighthouse), so
   this script now stops at once on any page that has the .atcr section.

   Two markups are handled elsewhere:
     - product review widget (new): .jm-review-body-wrapper > .jm-review-content__body
     - old all-reviews markup: .jdgm-rev__content > .jdgm-rev__body

   Speed: all new reviews are measured in one batch (two layouts in total),
   the work waits for an idle moment, and the observer callback only
   schedules. Hidden reviews (measure 0) are left unmarked and measured again
   once they show. */
(function () {
  if (document.querySelector('.atcr')) return;

  var queued = false;
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 1); };

  function setup() {
    queued = false;

    var wraps = document.querySelectorAll('.jm-review-body-wrapper:not([data-atc-rev]), .jdgm-rev__content:not([data-atc-rev])');
    if (wraps.length) {
      var todo = [];
      for (var i = 0; i < wraps.length; i++) {
        var body = wraps[i].querySelector('.jm-review-content__body, .jdgm-rev__body');
        if (body) todo.push({ w: wraps[i], b: body });
      }
      var k;
      for (k = 0; k < todo.length; k++) todo[k].c = todo[k].b.getBoundingClientRect().height;
      for (k = 0; k < todo.length; k++) todo[k].w.classList.add('atc-rev-open');
      for (k = 0; k < todo.length; k++) todo[k].f = todo[k].b.getBoundingClientRect().height;
      for (k = 0; k < todo.length; k++) todo[k].w.classList.remove('atc-rev-open');

      for (k = 0; k < todo.length; k++) {
        if (!todo[k].c && !todo[k].f) continue; /* hidden now - measure later */
        todo[k].w.setAttribute('data-atc-rev', '1');
        if (todo[k].f - todo[k].c < 4) continue;
        (function (w, body) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'atc-rev-toggle';
          b.textContent = 'Read more';
          b.addEventListener('click', function () {
            b.textContent = w.classList.toggle('atc-rev-open') ? 'Read less' : 'Read more';
          });
          if (w.classList.contains('jdgm-rev__content')) body.insertAdjacentElement('afterend', b);
          else w.appendChild(b);
        })(todo[k].w, todo[k].b);
      }
    }

    var list = document.querySelector('.jdgm-review-list:not([data-atc-more])');
    if (list) {
      var items = list.querySelectorAll('.jm-review-item');
      if (items.length > 2) {
        list.setAttribute('data-atc-more', '1');
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'atc-rev-more';
        btn.textContent = 'Show more reviews';
        btn.addEventListener('click', function () {
          btn.textContent = list.classList.toggle('atc-rev-all') ? 'Show fewer reviews' : 'Show more reviews';
          schedule();
        });
        list.appendChild(btn);
      }
    }
  }

  function schedule() {
    if (queued) return;
    queued = true;
    setTimeout(function () { idle(setup, { timeout: 1500 }); }, 200);
  }

  function start() {
    schedule();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
